import browser, { dom } from '../../../../browser';

const MATHJAX_VERSION = '2.7.0';
const MATHJAX_PATH = `https://cdnjs.cloudflare.com/ajax/libs/mathjax/${MATHJAX_VERSION}/MathJax.js?config=TeX-AMS_HTML`;

let isMathjaxLoading = false;
const mathjaxLoadingPromisesResolvers = [];

function isMathjaxReady() {
  return !!browser.window.MathJax && !!browser.window.MathJax.Hub;
}

function getInstance() {
  if (isMathjaxReady()) {
    return Promise.resolve(browser.window.MathJax);
  }

  return new Promise((resolve) => {
    mathjaxLoadingPromisesResolvers.push(resolve);

    if (isMathjaxLoading) {
      return;
    }

    isMathjaxLoading = true;

    browser.window.MathJax = {
      messageStyle: 'none',
      skipStartupTypeset: true,
      showMathMenu: false,
      jax: ['input/TeX', 'output/HTML-CSS', 'output/CommonHTML'],
      extensions: [],
      TeX: {
        extensions: ['color.js', 'AMSmath.js', 'AMSsymbols.js', 'noErrors.js', 'noUndefined.js'],
      },
      tex2jax: {
        inlineMath: [
          ['\\(', '\\)'],
          ['$\\(', '\\)$'],
        ],
        displayMath: [
          ['\\[', '\\]'],
          ['$\\[', '\\]$'],
        ],
        skipTags: ['script', 'noscript', 'style', 'textarea', 'code'],
      },
    };

    dom.insertScript(MATHJAX_PATH).then(() => {
      const { MathJax } = browser.window;

      mathjaxLoadingPromisesResolvers.forEach((resolver) => resolver(MathJax));
      isMathjaxLoading = false;
    });
  });
}

function highlight(domElement) {
  return getInstance().then(
    (MathJax) =>
      new Promise((resolve) => {
        MathJax.Hub.Queue(['Typeset', MathJax.Hub, domElement], resolve);
      })
  );
}

export default {
  isMathjaxReady,
  getInstance,
  highlight,
};
